<template>
    <div ref="printBody">
      <h2 class="py-3 px-3 flex items-center">
        <img
        src="@/assets/images/icons/back-icon.svg"
        @click="$router.go(-1)"
        class="mr-4 cursor-pointer"
      />
        Booking Summary</h2>
  
      <div class="flex flex-wrap ">
        <SummaryItem
          img=""
          :label="shipping.shippingReference"
          title="SHIPPING REFERENCE"
        >
          <img
            src="@/assets/images/booking-management/svgs/order-number.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="shipping.createdAt.split('T')[0]"
          title="DATE CREATED"
        />
        <div class="lg:w-3/12 md:w-4/12 flex py-4 px-3 sm:w-6/12 w-full ">
          <span class="w-8"></span>
          <p class="w-full">
            <label class="opacity-50 text-sm block w-full">STATUS</label>
            <span
              class="text-sm inline-block px-3 py-2 text-primary-yellow rounded-md capitalize"
              style="background: rgba(252, 194, 16, 0.1)"
              >{{ shipping.deliveryStatus || "None" }}</span
            >
          </p>
        </div>
  
        <div class="lg:w-3/12 md:w-4/12 flex py-4 px-3 sm:w-6/12 w-full">
          <span class="w-8"></span>
          <p class="w-full flex items-center justify-end ">
            <span class="flex items-center mr-3 cursor-pointer"
            @click="modifyDraft"
            >
              <img src="@/assets/images/icons/WriteIcon.svg" class="mr-1" />
              Modify
            </span>
            <span class="flex items-center cursor-pointer" @click="printElement">
              <img src="@/assets/images/ondemand/print.svg" class="mr-1" />
              Print
            </span>
          </p>
        </div>
  
        <div class="w-3/12 flex py-4 px-3 "></div>
      </div>
  
      <div class="flex flex-wrap border-t-2 border-gray-200 pb-4 mb-4">
        <div class=" md:w-4/12 flex py-4 sm:w-6/12 w-full px-1">
          <div class="bg-primary-navy w-full flex text-white py-3 px-2">
            <span class="w-24 block mx-2"
              ><img src="@/assets/images/ondemand/user-photo.svg"
            /></span>
            <p class="w-full">
              <span>{{
                shipping.shipperlocation.contactName
                  ? shipping.shipperlocation.contactName
                  : "N/A"
              }}</span>
              <span class="text-gray-400 w-full flex pt-2 items-center">{{
                shipping.shipperlocation.email
                  ? shipping.shipperlocation.email
                  : "N/A"
              }}</span>
              <span class="text-gray-400 w-full block items-center">{{
                shipping.shipperlocation.mobile
                  ? shipping.shipperlocation.mobile
                  : "N/A"
              }}</span>
            </p>
          </div>
        </div>
  
        <div class=" md:w-4/12 flex py-4 sm:w-6/12 w-full px-1">
          <div
            class="bg-primary-navy  w-full flex items-start text-white py-3 px-2"
          >
            <span class="flex justify-center mx-3"
              ><img class="w-5" src="@/assets/images/icons/location.svg"
            /></span>
            <p class="w-full">
              <span>PICK-UP LOCATION</span>
              <span class="text-gray-400 pt-2 block w-full">{{
                shipping.shipperlocation.address
                  ? shipping.shipperlocation.address.name
                  : "N/A"
              }}</span>
            </p>
          </div>
        </div>
  
        <div class=" md:w-4/12 flex py-4 sm:w-6/12 w-full px-1">
          <div
            class="bg-primary-navy  w-full flex items-start text-white py-3 px-2"
          >
            <span class="flex justify-center mx-3"
              ><img class="w-5" src="@/assets/images/icons/location.svg"
            /></span>
            <p class="w-full">
              <span>RECEIVER</span>
              <span class="text-gray-400 block pt-2 w-full">{{
                shipping.consigneelocation.address
                  ? shipping.consigneelocation.address.name
                  : "N/A"
              }}</span>
            </p>
          </div>
        </div>
      </div>
  
      <div class="flex flex-wrap border-t-2 border-gray-200">
        <h2 class="py-3 px-3 w-full">Shipment Details</h2>
        <SummaryItem
          :label="
            shipping.shippingservice
              ? shipping.shippingservice.takeOffLocation
              : 'N/A'
          "
          title="ORIGIN"
        >
          <img src="@/assets/images/booking-management/svgs/port-of-origin.svg" />
        </SummaryItem>
  
        <SummaryItem label="Package" title="SPECIFIED SHIPMENT">
          <img
            src="@/assets/images/booking-management/svgs/specified-shipment.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="shipping.shippingMethod ? shipping.shippingMethod : 'N/A'"
          title="SHIPPING MODE"
        >
          <img
            src="@/assets/images/booking-management/svgs/shipping-mode.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" :label="totalpackageType" title="PACKAGE TYPE">
          <img
            src="@/assets/images/booking-management/svgs/package-type.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
            shipping.consigneelocation.state
              ? shipping.consigneelocation.state
              : 'N/A'
          "
          title="DESTINATION"
        >
          <img
            src="@/assets/images/booking-management/svgs/port-of-destination.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" label="Cloudenly" title="BOOKING CHANNEL">
          <img
            src="@/assets/images/booking-management/svgs/booking-channel.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
            shipping.shippingservice
              ? shipping.shippingservice.orgName
              : 'N/A'
          "
          title="SHIPPING OPTION"
        >
          <img
            src="@/assets/images/booking-management/svgs/shipping-option.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" label="N/A" title="WAYBILL NO">
          <img
            src="@/assets/images/booking-management/svgs/channel-waybill.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="totalpackageDiscription"
          title="PACKAGE DESCRIPTION"
        >
          <img
            src="@/assets/images/booking-management/svgs/channel-waybill.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
            shipping.shippingservice ? shipping.shippingservice.routeName : 'N/A'
          "
          title="ROUTE"
        >
          <img src="@/assets/images/booking-management/svgs/route.svg" alt="" />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
            shipping.shippingservice
              ? shipping.shippingservice.distance
              : '0' + ' KM'
          "
          title="DISTANCE"
        >
          <img
            src="@/assets/images/booking-management/svgs/distance.svg"
            alt=""
          />
        </SummaryItem>
      </div>
  
      <div class="flex flex-wrap border-t-2 border-gray-200">
        <h2 class="py-3 px-3 w-full pt-5">Package Details</h2>
        <SummaryItem
          img=""
          :label="shipping.packagees ? shipping.packagees.length : 'None'"
          title="NUMBER OF PACKAGES"
        >
          <img
            src="@/assets/images/booking-management/svgs/number-of-packages.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" :label="totalpackageWeight + ' KG'" title="WEIGHT">
          <img
            src="@/assets/images/booking-management/svgs/channel-waybill.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" :label="packageDimensions" title="DIMENSION (LxWxH)">
          <img
            src="@/assets/images/booking-management/svgs/dimension.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="totalpackageHandling"
          title="SPECIAL HANDLING"
        >
          <img
            src="@/assets/images/booking-management/svgs/special-handling.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="'₦ ' + totalpackageValue"
          title="DECLARED VALUE"
        >
          <img
            src="@/assets/images/booking-management/svgs/declared-value.svg"
            alt=""
          />
        </SummaryItem>
      </div> 
  
  
    
      <div class="flex flex-wrap border-t-2 border-gray-200">
        <h2 class="py-3 px-3 w-full pt-5">Payment Summary</h2>
        <SummaryItem img="" :label="paymentSummary" title="SERVICE">
          <img src="@/assets/images/booking-management/svgs/service.svg" alt="" />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
            
              (costEngine.netPrice
                ? '₦ ' +amountFomatter(costEngine.netPrice || 0)
                : '₦ 0')
          "
          title="NET SHIPPING COST"
        >
          <img
            src="@/assets/images/booking-management/svgs/net-shipping-cost.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" :label="(costEngine.handlingCharges ? '₦ ' + amountFomatter(costEngine.handlingCharges || 0) : '₦ 0')" title="HANDLING CHARGES">
          <img
            src="@/assets/images/booking-management/svgs/booking-channel.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" :label=" (costEngine.insuranceFee ? '₦ ' +amountFomatter(costEngine.insuranceFee || 0) : '₦ 0')" title="INSURANCE">
          <img
            src="@/assets/images/booking-management/svgs/insurance.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
            
              (shipping.shippingservice
                ? '₦ ' + amountFomatter(shipping.shippingservice.serviceCost || 0)
                : '₦ 0')
          "
          title="RETURN SHIPPING COST"
        >
          <img
            src="@/assets/images/booking-management/svgs/booking-channel.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" label="₦ 0" title="STOP/DIVERSION COST">
          <img
            src="@/assets/images/booking-management/svgs/stop-diversion-cost.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
          '₦ ' +(shipping.transaction ? amountFomatter(shipping.transaction.totalValue || 0) : '0')
          "
          title="TOTAL"
        >
          <img src="@/assets/images/booking-management/svgs/total.svg" alt="" />
        </SummaryItem>
        <SummaryItem img="" label="******" title="PROMO CODE">
          <img
            src="@/assets/images/booking-management/svgs/promo-code.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" label="₦ 0" title="DISCOUNT  TOTAL">
          <img
            src="@/assets/images/booking-management/svgs/number-of-packages.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem img="" :label="(costEngine.vat ? amountFomatter(costEngine.vat || 0)  : '₦ 0')" title="Tax/VAT">
          <img
            src="@/assets/images/booking-management/svgs/tax-vat-charges.svg"
            alt=""
          />
        </SummaryItem>
        <SummaryItem
          img=""
          :label="
          '₦ ' +(shipping.transaction ? amountFomatter(shipping.transaction.totalValue || 0) : '0')
          "
          title="PAYMENT DUE"
        >
          <img
            src="@/assets/images/booking-management/svgs/payment-due.svg"
            alt=""
          />
        </SummaryItem>
      </div>
  
      <div class="flex flex-wrap border-t-2 border-gray-200">
        <h2 class="py-3 px-3 w-full pt-5">
          This bill excludes duties and other government charges.
        </h2>
      </div>
  
      <!-- <div class="flex w-full items-center justify-between py-4 px-4">
        <button class="underline" @click="$emit('changeBookingTab', 4)">
          Back
        </button>
        <button
          @click="$emit('changeBookingTab', 7)"
          class="w-48 bg-primary-yellow py-2 shadow-lg"
        >
          Continue
        </button>
      </div> -->
    </div>
  </template>
  
  <script>
  import SummaryItem from './SummaryItem.vue';
  
  export default {
    data() {
      return {
        shipping: {},
        shippingId: this.$route.params.id,
      };
    },
    mounted() {
      this.getBookingSummary();
    },
    computed: {
      costEngine(){
         return JSON.parse(this.shipping?.transaction?.breakDown || `{}`)
      },
      paymentSummary() {
        return `${this.shipping?.shippingservice?.orgName || ""}  ${this.shipping
          ?.shippingservice?.routeName || "N/A"}`;
      },
      totalpackageWeight() {
        if(!this.shipping?.packagees.length) return 0
        return this.shipping?.packagees
          .map((item) => item.estimatedWeight)
          .reduce((prev, next) => prev + next);
   
      },
      totalpackageValue() {
        if(!this.shipping?.packagees.length) return 0
        return this.shipping?.packagees
          .map((item) => item.itemValue)
          .reduce((prev, next) => prev + next);
      },
      totalpackageDiscription() {
        if(!this.shipping?.packagees.length) return ""
        return this.shipping?.packagees
          .map((item) => item?.description)
          .reduce((prev, next) => prev + ", " + next);
      },
      totalpackageType() {
        if(!this.shipping?.packagees.length) return ""
        return this.shipping?.packagees
          .map((item) => item?.packageType)
          .reduce((prev, next) => prev + " " + next);
      },
      packageDimensions() {
        if(!this.shipping?.packagees.length) return ""
        return this.shipping?.packagees
          .map((item) => {
            if( !item?.length && !item?.width && !item?.height) return 'N/A';
            return (item?.length + "x" + item?.width + "x" + item?.height);
          })
          .reduce((prev, next) => prev + " " + next);
      },
      totalpackageHandling() {
        if (!this.shipping?.packagees[0]?.specialHandling?.length) return "";
        else {
          return this.shipping?.packagees[0]?.specialHandling
            .map((item) => item)
            .reduce((prev, next) => prev + ", " + next);
        }
      },
    },
    methods: {
      modifyDraft(){
          this.$store.dispatch("saveLatestNewShippingForSelf", false);
          this.$store.dispatch("saveLatestPrevShipper", this.shipping?.shipperlocation);
          this.$store.dispatch("saveLatestNewBookingConsignee", this.shipping?.consigneelocation);
          this.$store.dispatch("saveLatestNewBookinPackages", this.shipping?.packagees);
          this.$store.dispatch("actionQuoteShippingResponse", this.shipping?.shippingMethod);
          this.$router.push({ name: "BookingFlow" });
      },
      printElement() {
        // var domClone = elem.cloneNode(true);
  
        var $printSection = this.$refs.printBody;
  
        if (!$printSection) {
          $printSection = document.createElement("div");
          $printSection.id = "printSection";
          document.body.appendChild($printSection);
        }
  
        window.print();
      },
      async getBookingSummary() {
        try {
          const response = await this.$_getShipmentById(this.shippingId);
          this.shipping = response.data.data.shipping;
        } catch (error) {
          this.handleError(error);
        }
      },
    },
    components: {
      SummaryItem,
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  